<template>
    <div
        class="sbs-responsive"
        :style="dimensionStyles">
        <div
            class="sbs-responsive__stretcher trs"
            :style="stretcherStyles"></div>

        <div class="sbs-responsive__content trs">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import dimensionsMixin from '../../mixins/dimensions.js';

export default {
    name: 'SbsResponsive',
    mixins: [dimensionsMixin],
    computed: {
        computedAspectRatio() {
            return Number(this.aspectRatio);
        },
        stretcherStyles() {
            return {
                paddingBottom: this.computedAspectRatio
                    ? `${(1 / this.computedAspectRatio) * 100}%`
                    : '',
            };
        },
    },
    props: {
        /**
         * Коэффициент соотношения сторон контейнера
         * Например, 1.77 примерно равен соотношению 16:9
         */
        aspectRatio: {
            type: [Number, String],
            default: null,
        },
    },
};
</script>

<style lang="scss">
.sbs-responsive {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    max-width: 100%;
    overflow: hidden;

    &__stretcher,
    &__content {
        flex-basis: 0;
        flex-grow: 1;
        flex-shrink: 0;
    }

    &__stretcher {
        transition-property: padding-bottom;
    }

    &__content {
        max-width: 100%;
        margin-left: -100%;
    }
}
</style>
